import { Divider, Menu as MuiMenu } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDeleteChannelGuide } from '~/api/channel-guides/delete';
import { ConfirmDialog } from '~/components/dialogs/confirmation';
import { MoreDeleteAction } from '~/components/table';
import { useConfirmDialog } from '~/hooks/dialogs';
import type { MoreActionProps, MoreMenuProps } from '~/hooks/table';
import { assert } from '~/lib/assert';
import type { ChannelGuideSettings__ChannelGuide as ChannelGuide } from '../../queries/settings.generated';

export interface MenuProps {
  channelGuide: ChannelGuide | null | undefined;
  moreMenuProps: MoreMenuProps<ChannelGuide>;
  moreActionProps: MoreActionProps;
}

export const Menu = ({ moreMenuProps, moreActionProps }: MenuProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [deleteChannelGuide] = useDeleteChannelGuide();
  const [confirmDelete, confirmDeleteProps] = useConfirmDialog();

  return (
    <>
      <MuiMenu
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        {...moreMenuProps}
      >
        <Divider />
        <MoreDeleteAction
          {...moreActionProps}
          onClick={async () => {
            assert(moreMenuProps.context != null, 'delete: no device context');
            if (!(await confirmDelete())) return;
            await deleteChannelGuide({
              variables: {
                input: {
                  channelGuideIds: [moreMenuProps.context.id],
                },
              },
            });
            navigate('../..');
            moreMenuProps.onClose();
          }}
        />
      </MuiMenu>

      <ConfirmDialog
        {...confirmDeleteProps}
        cancel={t('common.actions.cancel')}
        confirm={t('common.dialogs.permanently_delete')}
        deleteConfirm
        prompt={t('pages.channel_guides.dialogs.delete.prompt')}
        title={t('pages.channel_guides.dialogs.delete.title')}
      />
    </>
  );
};
